module.exports = __webpack_public_path__ + "img/w3_mc_grey.9f061a8a.png";